export default function DateWheelPicker({ year, month, day, onYearChange, onMonthChange, onDayChange }) {
  const today = new Date();
  const years = Array.from({ length: 8 }, (_, i) => today.getFullYear() + i);
  const months = Array.from({ length: 12 }, (_, i) => i + 1);
  const daysInMonth = new Date(year, month, 0).getDate();
  const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  const handleMonthChange = (m) => {
    onMonthChange(m);
    const maxDay = new Date(year, m, 0).getDate();
    if (day > maxDay) onDayChange(maxDay);
  };

  const selectStyle = {
    padding: '7px 24px 7px 8px', borderRadius: 8, border: '1px solid #ddd',
    fontSize: 13, background: 'white', cursor: 'pointer',
    appearance: 'none', WebkitAppearance: 'none',
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 12 12'%3E%3Cpath fill='%23999' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 6px center',
    minWidth: 0,
  };

  const labelStyle = { fontSize: 13, color: '#555', flexShrink: 0 };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <select value={year} onChange={e => onYearChange(Number(e.target.value))} style={selectStyle}>
        {years.map(y => <option key={y} value={y}>{y}</option>)}
      </select>
      <span style={labelStyle}>년</span>

      <select value={month} onChange={e => handleMonthChange(Number(e.target.value))} style={selectStyle}>
        {months.map(m => <option key={m} value={m}>{String(m).padStart(2, '0')}</option>)}
      </select>
      <span style={labelStyle}>월</span>

      <select value={day} onChange={e => onDayChange(Number(e.target.value))} style={selectStyle}>
        {days.map(d => <option key={d} value={d}>{String(d).padStart(2, '0')}</option>)}
      </select>
      <span style={labelStyle}>일</span>
    </div>
  );
}
